<template>
    <form @submit.prevent="submit" ref="form">
        <text-input v-model="form.name" :errors="$page.props.errors.name" class="mb-3" label="Naam" />

        <button type="submit" class="mt-5 text-white bg-teal-700 px-5 py-3 rounded inline-block hover:bg-teal-800 focus:bg-teal-800">
            <i class="fal mr-1" :class="loading == 'submit' ? 'fa-spinner fa-spin' : 'fa-save'"></i>Opslaan
        </button>
    </form>
</template>

<script>
import Helpers from "@/admin/Mixins/GeneralHelpers.js";
import Layout from "@/admin/Shared/Layout";
import TextInput from "@/admin/Shared/TextInput";

export default {
    components: {
        TextInput,
    },

    mixins: [Helpers],

    props: {
        dataLoading: false,
        blogCategory: {
            type: Object,
            default() {
                return {};
            }
        }
    },

    watch: {
        dataLoading: function(loading) {
            this.loading = loading;
        }
    },

    data() {
        return {
            form: {
                name: this.blogCategory.name || "",
            }
        };
    },

    methods: {
        submit() {
            let data = {
                name: this.form.name,
            };

            this.$emit("submit", data);
        }
    }
};
</script>
